module.exports = __webpack_public_path__ + "img/logo2.480bbbc2.png";